export const detectCustomizerFieldsChange = <
  T extends Record<'themeColor' | 'themeMode' | 'themeFont', string | null>,
>(
  obj1: T,
  obj2: T
) => {
  // check that obj1 & obj2 are non-empty
  if (!obj1 || !obj2) return false

  // Get all keys from obj1
  const keys = Object.keys(obj1).filter((key) =>
    ['themeColor', 'themeMode', 'themeFont'].includes(key)
  ) as ('themeColor' | 'themeMode' | 'themeFont')[]

  // Iterate through each key and compare values in both objects
  for (let key of keys) {
    if (obj1[key] !== obj2[key]) {
      return true // At least one key has a different value
    }
  }

  return false // All keys have the same values
}
